<template>
  <v-app id="inspire" class="bodyPadding projectsScreen"> 
    <mo-header></mo-header>
    <v-content>
		<project-head></project-head>
		<project-list></project-list>
    </v-content>
  </v-app>
</template>

<script>

	import ProjectHead from './Header.vue';
	import ProjectList from './List.vue';
	import { mapGetters } from 'vuex'; 
	
	export default {
		data () {
			return {
		
			}		
		},
		components: {
            ProjectHead,
            ProjectList
		},
		computed: {
			...mapGetters([			
				'objAuthorize',
			])
		},
        created() {
            if( this.objAuthorize.privileges.indexOf('VIEW_PROJECTS') === -1 ) {
                this.$router.replace('/');
            }
        }
    }
</script>

<style scoped>
	@import '../shared/assets/css/shared.css';
</style>